import "core-js/stable";
import "regenerator-runtime/runtime";
import { Application } from "@hotwired/stimulus"
import "../javascripts/status_pages/tooltips"
import Dropdown from "stimulus-dropdown"
import ResponseTimeChartController from "../javascripts/status_pages/response_time_chart_controller"
import TimezoneController from "../javascripts/status_pages/timezone_controller"
import TimeController from "../javascripts/status_pages/time_controller"
import SaveScrollPositionController from "../javascripts/status_pages/save_scroll_position_controller"

const Stimulus = Application.start()

Stimulus.register("response-time-chart", ResponseTimeChartController)
Stimulus.register("dropdown", Dropdown)
Stimulus.register("timezone", TimezoneController)
Stimulus.register("time", TimeController)
Stimulus.register("save-scroll-position", SaveScrollPositionController)
